import { callApiWithAuthorization } from "../../../API/CallApi";

/**
 * [getAllAttributes gets all the attributes of an entity]
 * @param  {[string]} entityId [entity id of an entity, whose attributes are returned]
 * @return {Promise<Attribute[]>}          [all attributes of an entity]
 */

export async function getAllAttributes(entityId) {
	let getAttributesRequest = await callApiWithAuthorization("/api/v0/nodes/" + entityId + "/getAllAttributes");
	let attributes = await getAttributesRequest.json();
	return attributes;
}

/**
 * [getAllLinkedEntities gets all the linked entity of an entity]
 * @param  {[string]} entityId [entity id on an entity, whose linked entities are returned]
 * @return {[LinkedEntity[]]}          [all linked entities of an entity]
 */

export async function getAllLinkedEntities(entityId) {
	let getAllLinkedEntitiesRequest = await callApiWithAuthorization("/api/v0/nodes/" + entityId + "/SubEntity");
	let linkedEntities = await getAllLinkedEntitiesRequest.json();
	return linkedEntities.data;
}

/**
 * [getAllPages return all the pages only of created under entity]
 * @param  {[string]} entityId [id of the entity]
 * @return {[Page[]]}          [all the pages under the entity with id entityId]
 */
export async function getAllPages(entityId) {
	let getAllPagesRequest = await callApiWithAuthorization("/api/v0/nodes/" + entityId + "/pagesOnly");
	let pages = await getAllPagesRequest.json();
	return pages;
}

/**
 * [getAllComponents returns all the components of a page]
 * @param  {[string]} pageId [id of the page]
 * @return {[Component[]]}        [tree of the component of a page]
 */
export async function getAllComponents(pageId) {
	const request = await callApiWithAuthorization('/api/v0/nodes/' + pageId + "/components");
	const response = await request.json();
	const components = response.records[0]?._fields[0]?.has_component;
	return components;
}

/**
 * [getRelatedEntityAttributes returns reference attributes of a linked entity]
 * @param  {[string]} entityId [id of the linked entity]
 * @return {[Attribute[]]} Reference attributes of the linked entity]
 */

export async function getRelatedEntityAttributes(entityId, attributeType) {
	const request = await callApiWithAuthorization("/api/v0/entity/" + entityId + "/relatedEntityAttributes?attributeType=" + attributeType);
	const result = await request.json();
	return result;
}

export async function getUserAndOrganizationData(email) {
	const response = await callApiWithAuthorization(`/api/v0/getOrganizationUserRole/${email}`);
	const roleOfUserInOrganisations = await response.json();
	return roleOfUserInOrganisations;
}

export async function getProjectRelations(projectId) {
	const request = await callApiWithAuthorization(`/api/v0/project/${projectId}/entityRelations`);
	const response = await request.json();
	return response;
}